const BASE_URL = "https://api.dyrk.app";
export const AWS_URL = "https://growapp-i2a.s3.eu-north-1.amazonaws.com";

export { BASE_URL };
export default { BASE_URL };
